import getIn from 'transmute/getIn';
import { defaultMemoize } from 'reselect';
export const getUserSettingsAsyncData = defaultMemoize(getIn(['userSettings']));